export function HamburgerIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 16.1412H23.8609V13.451H0V16.1412ZM0 9.41567H23.8609V6.72548H0V9.41567ZM0 0V2.69019H23.8609V0H0Z"
        fill="url(#paint0_linear_4446_7710)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4446_7710"
          x1="-4.51911"
          y1="2.2238e-06"
          x2="25.0153"
          y2="3.98405"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00961538" stopColor="#F15A29"/>
          <stop offset="0.413462" stopColor="#F6881F"/>
          <stop offset="0.649038" stopColor="#F7941D"/>
          <stop offset="1" stopColor="#EF4130"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
